import "./index.css";
import React, { Fragment } from "react";
import { CurrencyOptions } from "../../../../Constants/retailer";
import { PaymentFrequencyOptions } from "../../../../screens/super_products/components/Popup/components/PaymentFrequencyInput/constants";

export default function ProductPrice({ product, territory }) {
  const isDigital = product.productType.value === "digital";

  const formatAmount = (amount) => {
    const numDecimals = amount % 100 > 0 ? 2 : 0;
    return (amount / 100).toFixed(numDecimals);
  };

  const formatFrequency = () => {
    const frequencyObj = PaymentFrequencyOptions.find(
      (option) => option.value === product.price.frequency
    );
    return frequencyObj ? frequencyObj.label.toLowerCase() : "per item";
  };

  return (
    <div className="product-price">
      <div>
        <span className="product-price__currency" aria-hidden="true">
          {CurrencyOptions[territory]}
        </span>
        <span className="product-price__amount" aria-label="Amount">
          {formatAmount(product.price.amount)}
        </span>
      </div>
      <span className="product-price__frequency" aria-label="Frequency">
        {isDigital ? "per" : formatFrequency(product.price.frequency)}
      </span>
      {isDigital && (
        <Fragment>
          <span className="product-price__amount" aria-label="Quantity">
            100
          </span>
          <span className="product-price__unit" aria-label="Unit">
            tokens
          </span>
        </Fragment>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Package/components/ProductPrice/index.js